import { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchMyAssets,
  fetchAssetSummary,
  raiseAssetQuery,
  openQueryModal,
  closeQueryModal,
} from "../store/slices/myAssetsslice";

export default function useMyAssets({ autoFetch = true } = {}) {
  const dispatch = useDispatch();

  const {
    assets,
    summary,
    status,
    error,
    queryModal,
    queryStatus,
    queryError,
  } = useSelector((state) => state.myAssets);

  useEffect(() => {
    if (autoFetch) {
      dispatch(fetchMyAssets());
      dispatch(fetchAssetSummary());
    }
  }, [autoFetch, dispatch]);

  const refresh = useCallback(
    (params) => {
      dispatch(fetchMyAssets(params));
      dispatch(fetchAssetSummary(params));
    },
    [dispatch]
  );

  const openQuery = useCallback(
    (assetId) => dispatch(openQueryModal(assetId)),
    [dispatch]
  );

  const closeQuery = useCallback(
    () => dispatch(closeQueryModal()),
    [dispatch]
  );

const submitQuery = useCallback(
  async (assetId, message) => {
    if (!assetId) return;
    const result = await dispatch(
      raiseAssetQuery({ assetId, message })
    );
    if (raiseAssetQuery.fulfilled.match(result)) {
      dispatch(fetchMyAssets());
      dispatch(fetchAssetSummary());
    }
    return result;
  },
  [dispatch]
);

  return {
    assets,
    summary,
    status,
    error,
    isLoading: status === "loading",

    queryModal,
    queryStatus,
    queryError,
    isQuerySubmitting: queryStatus === "loading",

    refresh,
    openQuery,
    closeQuery,
    submitQuery,
  };
}